export const formatCurrency = (
  amount: number | null | undefined,
  showSymbol = true,
): string => {
  if (amount == null) return '-';
  const formatted = new Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency: 'IDR',
    minimumFractionDigits: 0,
  }).format(amount);
  return showSymbol ? formatted : formatted.replace('Rp', '').trim();
};
